<template>
  <div>
    <q-dialog v-model="show" @input="() => $emit('input', false)">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{
              this.$gettext("BILL_INSTALLMENT")
            }}</q-toolbar-title>
            <q-btn v-close-popup flat round dense icon="close" />
          </q-toolbar>
        </q-header>
        <q-page-container class="tw-p-4 tw-overflow-hidden">
          <div class="tw-flex tw-justify-between  tw-items-center">
            <div class="tw-flex tw-justify-center">
              <jt-select
                class="tw-pr-4"
                v-model="agreementInvoiceType"
                :label="$gettext('SELECT')"
                :options="optionAgreemntInvoiceType"
                @input="changeType"
              />
              <jt-select
                v-if="agreementInvoiceType == 50310002"
                v-model="dayExtensionInvoice"
                :label="$gettext('DAY_OF_MONTH')"
                :options="optionsDaysAgreementInvocieType"
              />

              <jt-input
                v-if="agreementInvoiceType == 50310003"
                v-model="dateGroupingInvoice"
                class="tw-w-1/3"
                ref="input"
                name="jtsearch-input"
                type="date"
                format="DD/MM/YYYY"
                :float-label="$gettext('PAYMENT_DATE')"
              />
              <div v-if="dateGroupingInvoice" class="tw-flex tw-flex-col tw-pl-4">
                <div class="tw-p-1 tw-whitespace-nowrap tw-bg-coolGray-100">{{$gettext('INVOICE_DOCUMENT_VALUE')}} <strong>{{$toLocaleStringBr(totalValueInvoices)}}</strong></div>
                <q-separator/>
                <div class="tw-p-1 tw-whitespace-nowrap tw-bg-coolGray-100">{{$gettext('MATURITY_DATE')}} <strong>{{ dateGroupingInvoice }}</strong></div>
              </div>
            </div>
          </div>
          <invoice-selected-steep
            @hideModal="hideModal"
            :extensionDateDay="dayExtensionInvoice"
            isHideDebts
          />
        </q-page-container>
        <footer class="tw-bg-white tw-fixed tw-bottom-0 tw-w-full tw-p-4">
          <div class="tw-flex tw-justify-center tw-gap-4">
            <q-btn
              class="tw-w-1/5"
              :label="isFirstStep ? $gettext('CANCEL') : $gettext('BACK')"
              color="grey-7"
              @click="onCancelClick"
            />
            <q-btn
              class="tw-w-1/5"
              :label="$gettext('SAVE')"
              :color="isDisabledContinueButton?'grey-7':'info'"
              @click="onContinue"
              :disable="isDisabledContinueButton"
            />
          </div>
        </footer>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import InvoiceSelectedSteep from '../negotiation/extension-modal/InvoiceSelectedSteep.vue'
import { JtDataTable, JtInput, JtSelect } from 'jtech-webcomps'
import { repository } from 'jtech'
import ExtensionController from './ExtensionController'
import ServiceRequestController from 'src/modules/concession/service-request/ServiceRequestController'

@Component({
  name: 'ExtensionModal',
  components: {
    JtInput,
    JtSelect,
    JtDataTable,
    InvoiceSelectedSteep
  },
  props: {
    consumerUnit: String,
    protocol: String,
    show: {
      type: Boolean,
      default: false
    }
  }
})
class ExtensionModal extends Vue {
  agreementInvoiceType = null
  dayExtensionInvoice = null
  dateGroupingInvoice = null
  extensionController = ExtensionController.getInstance()
  controller = ServiceRequestController.getInstance()

  onCancelClick () {
    this.hideModal()
  }

  hideModal () {
    this.$emit('input', false)
  }

  get totalValueInvoices () {
    return this.extensionController.getInvoices().reduce((accumulator, invoice) => {
      return accumulator + parseFloat(invoice.valor.replace(',', '.'))
    }, 0.00)
  }

  changeType () {
    this.dateGroupingInvoice = null
    this.dayExtensionInvoice = null
  }

  get isDisabledContinueButton () {
    return !this.dayExtensionInvoice && !this.dateGroupingInvoice
  }

  async onContinue () {
    await repository.create('agreementInvoice.gravar', {
      agreementInvoiceType: this.agreementInvoiceType,
      invoiceIds: this.extensionController.getInvoices().map(i => i.id),
      documentClient: this.controller.state.serviceRequests[this.protocol].clientID,
      consumerUnit: this.controller.state.serviceRequests[this.protocol].consumerUnits[this.consumerUnit].id,
      dayExtensionInvoice: this.dayExtensionInvoice,
      dateGroupingInvoice: this.dateGroupingInvoice
    })
    this.hideModal()
  }

  get optionAgreemntInvoiceType () {
    return [{ value: 50310002, label: this.$gettext('NEW_INVOICE_DUE_DATE') }, { value: 50310003, label: this.$gettext('UNION_INVOICE') }]
  }

  get optionsDaysAgreementInvocieType () {
    return [{ value: 15, label: '15' }, { value: 20, label: '20' }, { value: 25, label: '25' }, { value: 30, label: '30' }]
  }
}

export default ExtensionModal
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";

</style>
